import { dataMember, required } from 'santee-dcts';
import { UserSettings } from './user-settings';
import { UserMetadata } from './user-metadata';
import { AudienceRoleName } from '../authentication/audience-role';

export class User {

    public readonly investigatorRoleName: AudienceRoleName = 'Investigator';
    public readonly sponsorRoleName: AudienceRoleName = 'Sponsor';
    public readonly adminRoleName: AudienceRoleName = 'Admin';
    public readonly internalRoleName: AudienceRoleName = 'Internal';
    public readonly systemAdminRoleName: AudienceRoleName = 'System Admin';

    @dataMember()
    @required()
    public metadata: UserMetadata;

    @dataMember()
    @required()
    public settings: UserSettings;

    public get isSponsor() {
        return this.metadata.audienceRole === this.sponsorRoleName;
    }

    public get isInvestigator() {
        return this.metadata.audienceRole === this.investigatorRoleName;
    }

    public get isAdmin() {
        return this.metadata.audienceRole === this.adminRoleName;
    }

    public get isSystemAdmin() {
        return this.metadata.audienceRole === this.systemAdminRoleName;
    }

    public get isInternal() {
        return this.metadata.audienceRole === this.internalRoleName;
    }

    public get isSponsorOrInvestigator() {
        return this.isSponsor || this.isInvestigator;
    }

    public static notSupportedRoleError(): Error {
        return new Error('Role is not supported');
    }
}   